import { api } from '@/api/client';

export type TagColor =
  | 'mint'
  | 'cyan'
  | 'blue'
  | 'purple'
  | 'amber'
  | 'rose'
  | 'yellow'
  | 'indigo'
  | 'neutral';

export interface TagResponse {
  id: string;
  name: string;
  color: TagColor | null;
  usage_count: number;
}

export interface TagCreate {
  name: string;
  color?: TagColor | null;
}

export const tagsApi = {
  list: (tenantId: string) =>
    api.get<TagResponse[]>(`/tenants/${tenantId}/tags`),

  create: (tenantId: string, req: TagCreate) =>
    api.post<TagResponse>(`/tenants/${tenantId}/tags`, req),

  delete: (tagId: string) => api.delete<null>(`/tags/${tagId}`),

  setCredentialTags: (credentialId: string, tagIds: string[]) =>
    api.put<string[]>(`/credentials/${credentialId}/tags`, { tag_ids: tagIds }),

  setNoteTags: (noteId: string, tagIds: string[]) =>
    api.put<string[]>(`/notes/${noteId}/tags`, { tag_ids: tagIds }),
};
